import { Orders } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function OrderPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Orders", href: "/orders" },
          { title: "Edit Order", href: `/orders/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Order</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Orders.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
